import { useSyncExternalStore } from "react"
import {
  completionInboxEntries,
  subscribeCompletionInbox,
} from "./completion-inbox"

export const useCompletionInbox = () =>
  useSyncExternalStore(subscribeCompletionInbox, completionInboxEntries)
